import script from "./LikeModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./LikeModal.vue?vue&type=script&lang=ts&setup=true"

import "./LikeModal.vue?vue&type=style&index=0&id=0b09796d&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2780876773/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b09796d"]])

export default __exports__